import React from 'react';
import ReactDOM from 'react-dom/client';
import '@mantine/core/styles.css';
import '@mantine/notifications/styles.css';
import '@mantine/dates/styles.css';
import './styles/global.css';
import { AppProviders } from './providers/AppProviders';
import App from './App';
import { startPwaUpdates } from './lib/pwaUpdate';

startPwaUpdates();

// The saved appearance is applied by the inline script in index.html before the first paint;
// MantineProvider (colour-scheme manager in theme/colorScheme.ts) takes over from there.
ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <AppProviders>
      <App />
    </AppProviders>
  </React.StrictMode>,
);
